import React from "react";
import WebDevImg from "../images/i1.jpeg";
import DataImg from "../images/12.jpeg";
import PowerBIImg from "../images/i3.png";
import { Code, Database, BarChart2 } from "lucide-react";

const modules = [
  {
    title: "Full Stack Web Development",
    icon: <Code className="w-6 h-6 text-white" />,
    img: WebDevImg,
    description:
      "Learn the basics of Java, HTML, CSS, JavaScript, and how to build full-stack apps using React and Node.js.",
    color: "bg-indigo-600",
  },
  {
    title: "Data Analysis & Automation",
    icon: <Database className="w-6 h-6 text-white" />,
    img: DataImg,
    description:
      "Use Python and SQL to handle data, automate simple tasks, and extract useful insights from files or databases.",
    color: "bg-sky-600",
  },
  {
    title: "Power BI & Dashboard Reporting",
    icon: <BarChart2 className="w-6 h-6 text-white" />,
    img: PowerBIImg,
    description:
      "Create clean and interactive dashboards using Power BI with Excel or CSV data sources.",
    color: "bg-yellow-500",
  },
];

const ITModules = () => {
  return (

     <div className="max-w-6xl mx-auto">
    {/* Heading */}
        <h2 className="text-3xl sm:text-4xl font-bold text-sky-800 text-center mb-12">
          IT Internship Modules
        </h2>
    <div className="max-w-6xl mx-auto px-4 py-14 grid gap-10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {modules.map((mod, index) => (
        <div
          key={index}
          className="relative bg-white rounded-xl shadow-lg hover:shadow-2xl transition duration-300 group"
        >
          {/* Image */}
          <div className="overflow-hidden rounded-t-xl">
            <img
              src={mod.img}
              alt={mod.title}
              className="w-full h-48 object-cover transform group-hover:scale-105 transition duration-300"
            />
          </div>

          {/* Icon badge */}
          <div className={`absolute -top-5 left-5 p-3 rounded-full shadow-md ${mod.color}`}>
            {mod.icon}
          </div>

          {/* Content */}
          <div className="p-6">
            <h3 className="text-lg font-bold text-gray-800 mb-2">{mod.title}</h3>
            <p className="text-gray-600 text-sm leading-relaxed">{mod.description}</p>
          </div>
        </div>
      ))}
    </div>
    </div>
  );
};

export default ITModules;
